export const addressConstants = {
    REQUEST_AUTOCOMPLET_ADDRESS: 'REQUEST_AUTOCOMPLET_ADDRESS',
    REQUEST_AUTOCOMPLET_SUCCESS: 'REQUEST_AUTOCOMPLET_SUCCESS',
    REQUEST_AUTOCOMPLET_FAILURE: 'REQUEST_AUTOCOMPLET_FAILURE',
    REQUEST_GEOJSON_CITY: `REQUEST_GEOJSON_CITY`,
    REQUEST_GEOJSON_CITY_SUCCESS: `REQUEST_GEOJSON_CITY_SUCCESS`,
    REQUEST_GEOJSON_CITY_FAILURE: `REQUEST_GEOJSON_CITY_FAILURE`,
    REQUEST_AUTOCOMPLET_CITY: `REQUEST_AUTOCOMPLET_CITY`,
}
